export default __webpack_public_path__ + "static/media/image1.fa2329e2.jpg";